'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdQuestionAnswer = function MdQuestionAnswer(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 20c0 0.9-0.8 1.6-1.8 1.6h-16.6l-6.6 6.8v-23.4c0-0.9 0.7-1.6 1.6-1.6h21.6c1 0 1.8 0.7 1.8 1.6v15z m6.6-10c0.9 0 1.6 0.7 1.6 1.6v25l-6.6-6.6h-18.4c-0.9 0-1.6-0.7-1.6-1.6v-3.4h21.6v-15h3.4z' })
        )
    );
};

exports.default = MdQuestionAnswer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/question-answer.js
// module id = 3237
// module chunks = 0